<div class="sidebar-tab-page-content copo-no-user-select sidenav-content" [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller" cdkScrollable>
	<copo-panel-header [titleHeaderText]="'guarantee.request.drafts' | translate" (backButtonClick)="goBack()">
		</copo-panel-header>

	<div class="draft-list">
		<ng-template #loading>
			<copo-loading-spinner></copo-loading-spinner>
		</ng-template>
		<ng-container *ngIf="draftList && !isLoading; else loading" copoAfterViewInit (afterviewinit)="scroller.restoreState()">
			<div *ngFor="let draft of draftList" class="grid-column-one-full card-block">
				<div class="card-header">
					<div class="card-header-left">
						<mat-icon svgIcon="ordered" class="header-margin-right"></mat-icon>
						<div class="card-header-column-draft">
							<span translate>guarantee.client.project.name</span>
							<span>{{ draft.name | uppercase }}</span>
						</div>
					</div>
				</div>
				<div class="card-content">
					<div class="card-container-column-draft">
						<span class="card-content-label-draft draft-title" translate>draft.creationdate</span>
						<span class="overflow-wrap">{{draft.createdDate ? (draft.createdDate | copoDate:'date') : ''}}</span>
					</div>
					<div class="card-container-column-draft">
						<span class="card-content-label-draft draft-title" translate>draft.lastupdate</span>
						<span class="overflow-wrap">{{ draft.lastModifiedDate ? (draft.lastModifiedDate | copoDate:'date') : ''}}</span>
					</div>
					<div class="card-container-column-draft">
						<span class="card-content-label-draft draft-title" translate>claim.created.by</span>
						<span class="overflow-wrap">{{ draft.requesterName }}</span>
					</div>
					<div class="card-container-column-draft card-column-around">
						<div class="card-container-link" *ngIf="draft.id!== undefined">
							<button type="button" mat-icon-button class="draft-box-shadow-icon card-container-large-link-span"
								(click)="eveEditDraft(draft.id)" [matTooltip]="'edit.draft' | translate">
								<mat-icon color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
								</mat-icon>
							</button>
							<button type="button" mat-icon-button class="draft-box-shadow-icon card-container-large-link-span"
								(click)="evtDeleteDraft(draft)" [matTooltip]="'quapp.action.delete' | translate">
								<mat-icon color="accent" svgIcon="garbage" class="image-draft-list-icon"></mat-icon>
							</button>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>